export function imageSize(image: string): Promise<[number, number]> {
  return new Promise((resolve, reject) => {
    try {
      const img = new Image()

      img.onload = () => {
        resolve([img.width, img.height])
      }

      img.src = image
    } catch (e) {
      reject(e)
    }
  })
}